module.exports = __webpack_public_path__ + "static/media/logo-ico.86436ad2.svg";